import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { Avatar, Heading, Paragraph, PlainCard, Skeleton } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import moment from 'moment';
import { useModalLink } from 'navigation/ModalNavigation';

export default Skeleton(
	function NoteCard(props: {
		note: graphql.Note;
		userID: string;
		linkPrefix?: string;
		compact?: boolean;
		modal?: boolean;
	}) {
		const { t } = useTranslation();

		const link = useModalLink(
			`${props.linkPrefix ?? ''}/notes/${props.note.id}`,
			props.modal ?? false,
		);

		return (
			<PlainCard to={link}>
				<Flex
					alignItems={props.compact ? 'flex-start' : 'center'}
					flexDirection={props.compact ? 'column' : 'row'}
				>
					<Box pt={props.compact ? 2 : 3} pb={props.compact ? 2 : 3} flexGrow={1} flexShrink={1}>
						<Paragraph>
							{t('note.index.card.createdAt', {
								date: moment(props.note.createdAt).format('LL'),
							})}{' '}
							{!props.compact && (
								<>
									&middot;{' '}
									{t('note.index.card.updatedAt', {
										date: moment(props.note.updatedAt).format('LL'),
									})}
								</>
							)}
						</Paragraph>
						<Heading mt={2}>
							{props.note.title ||
								t('note.index.card.title', {
									date: moment(props.note.createdAt).format('LL'),
								})}
						</Heading>
					</Box>
					<Flex flexGrow={0} flexShrink={0} mb={props.compact ? 2 : 0}>
						<Avatar.List nodes={props.note.collaborators.edges} />
					</Flex>
				</Flex>
			</PlainCard>
		);
	},
	function NoteCardSkeleton(props: { compact?: boolean }) {
		return (
			<PlainCard.Skeleton>
				<Flex
					alignItems={props.compact ? 'flex-start' : 'center'}
					flexDirection={props.compact ? 'column' : 'row'}
				>
					<Box pt={props.compact ? 2 : 3} pb={props.compact ? 2 : 3} flexGrow={1} flexShrink={1}>
						<Paragraph.Skeleton lines={1} />
						<Heading.Skeleton mt={2} />
					</Box>
					<Flex flexGrow={0} flexShrink={0} mb={props.compact ? 2 : 0}>
						<Box mr={2}>
							<Avatar.Skeleton size={32} />
						</Box>
						<Box mr={2}>
							<Avatar.Skeleton size={32} />
						</Box>
					</Flex>
				</Flex>
			</PlainCard.Skeleton>
		);
	},
);
